export const NOT_SPECIFIED = 'Not Specified';

export default null;
